import Button from "components/formElements/Button/Button";
import { VStack } from "components/Stack";
import { useTranslation } from "react-i18next";

type Props = {
  tm: string | null;
  onNextStep: () => void;
};

function Welcome(props: Props) {
  const { t } = useTranslation();
  const isTeamManager = props.tm === "true";

  return (
    <div className={"welcome-step"}>
      <h1 className={"step-title"}>
        {t(isTeamManager ? "Signup.beenInvitedToTeam" : "Signup.beenInvitedToJoin")}
      </h1>

      <VStack className={"content"} align={"center"}>
        <div>
          <p>
            {isTeamManager
              ? t("Signup.yourCompanyHasInvited")
              : t("Signup.inviteToImprove")}
          </p>

          <ul>
            <li>{t("Signup.Set your password")}</li>
            <li>{t("Signup.Tell us more about you")}</li>
            <li>
              {isTeamManager
                ? t("Signup.Select relevant business English topics")
                : t("Signup.Select area’s you would like to focus on")}
            </li>
          </ul>

          <Button className={"btn"} onClick={props.onNextStep}>
            {t("Signup.Get Started")}
          </Button>
        </div>
      </VStack>
    </div>
  );
}

export default Welcome;
